import LegacyUpsell from './LegacyUpsell';

export default LegacyUpsell;
